import { createModel } from "hox";
import { useState } from "react";
import { ISelectOption } from "@src/components/YhFormBox/Types";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@src/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination } from "@src/utils/utils";
import { ISearchPage } from "@src/types/FmsTypes";
import { rosterService } from "./rosterService";
import { dictService } from "@src/views/authPortal/base/dict/DictService";

export const contractInfoModel = createModel(function () {
    const [print, setPrint] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<any[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [contraceHoldTypeDs, setContraceHoldTypeDs] = useState<ISelectOption[]>();
    const [contraceTypeDs, setContraceTypeDs] = useState<ISelectOption[]>();

    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const resetSearchParam = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
    }

    const loadDs = async () => {
        const contraceHoldTypes = await dictService.dictItemDs('Contract type');
        const contraceTypes = await dictService.dictItemDs('type of contract');
        setContraceHoldTypeDs(contraceHoldTypes);
        setContraceTypeDs(contraceTypes);
    }

    const loadData = async (page?: ISearchPage, searchValue: any = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await rosterService.contractInfoPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    return {
        searchParam,
        dataSource,
        pgCfg,
        initPgCfg,
        setSearchParam,
        setDataSource,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData, loadDs,
        print, setPrint,
        loading, setLoading,
        contraceTypeDs, contraceHoldTypeDs,
    }
})